import React, { useEffect, useMemo } from "react";
import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import { array, bool, func, object, oneOfType, string } from "prop-types";
import { MODAL_ANI_TYPES, modalAnimations } from "../../utils/modal-animations";
import { DomPortal } from "../";
import "./style.scss";
const SiteModal = ({ open = false, onMaskClick, animation = MODAL_ANI_TYPES.flipDown, className, children }) => {
  const modalProps = useMemo(() => modalAnimations[animation], [animation]);
  const modalMaskAnimations = {
    start: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.3 } }
  };
  const rootClasses = classNames("c-modal", className);
  useEffect(() => {
    if (open) {
      document.getElementsByTagName('html')[0].className = 'modal-open';
      window.scrollBody= document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // document.body.style.position = "fixed";
      document.body.classList.add("modal-open");
    } else {
      // document.body.style.position = "relative";
      window.scrollTo(window.scrollBody,window.scrollBody); 
      document.body.classList.remove("modal-open");
      document.getElementsByTagName('html')[0].className = '';
    }
  }, [open]);

  useEffect(() => {
    return () => {
      document.body.classList.remove("modal-open");
      // document.body.style.position = "relative";
      document.getElementsByTagName('html')[0].className = '';
    };
  }, []);
  return (
    <DomPortal>
      <AnimatePresence>
        {open && (
          <motion.div className={rootClasses} variants={modalMaskAnimations} initial="start" animate="visible" exit="exit">
            <div className="c-modal__mask" onClick={onMaskClick} />
            <motion.div {...modalProps} className="c-modal__content" initial="start" animate="visible" exit="exit">
              {children}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </DomPortal>
  );
};
export default SiteModal;
SiteModal.propTypes = {
  open: bool,
  onMaskClick: func,
  className: string,
  children: oneOfType([object, string, array])
};
